import * as React from 'react';
import {createRoot} from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import {BrowserRouter, Route, Routes,} from "react-router-dom";

import App, {AppWelcomePage} from "./app";
import Login from "./pages/login";
import Logout from "./pages/logout";
import NotFoundPage from "./pages/404";
import {ThemeProvider} from "@mui/material";
import {theme} from "./components/layout/theme";
import {store} from "./store";
import {Provider} from 'react-redux';
import {SnackbarProvider} from "notistack";
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {LocalizationProvider} from '@mui/x-date-pickers';
import "./styles/globals.scss";
import "react-big-calendar/lib/css/react-big-calendar.css";
import {AdminPage} from "./pages/admin";
import {AdminLayout} from "./pages/admin/layout";
import {UserProfile} from "./pages/user/profile";
import {CandidatePage} from './pages/candidate';
import dayjs from "dayjs";
import 'dayjs/locale/es';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isoWeek from 'dayjs/plugin/isoWeek';
import {CandidateTestPage} from "./pages/candidate/test";
import {PublicRecruitmentsPage} from "./pages/candidate/recruitments";
import AdminBillingRoutes from "./route_admin_billings";
import AdminEmployeeRoutes from "./route_admin_employee";
import AdminRecruitmentRoutes from "./route_admin_recruitment";
import AdminAccountingRoutes from "./route_admin_accounting";
import AdminMarketingRoutes from "./route_admin_marketing";
import AdminComplianceRoutes, {ComplianceRedirects} from "./route_admin_compliance";
import EmployeeRoutes from "./route_employee";
import ConfigRoutes from "./route_config";
import {SupportPage} from "./pages/evaluation";
import {SearchPage} from "./pages/admin/search";
import {listenForInstallPrompt} from "./components/utils/install_prompt";

const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);

dayjs.extend(customParseFormat);
dayjs.extend(isoWeek);
dayjs.locale('es');

// App instalable de fichar (#13811). Solo en producción: en desarrollo un service worker se queda
// con páginas viejas de Vite y despista.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
	listenForInstallPrompt();
	window.addEventListener("load", () => {
		navigator.serviceWorker.register("/sw.js").catch(e => console.warn("No se pudo registrar el service worker", e));
	});
}

root.render(
	<React.StrictMode>
		<CssBaseline/>
		<ThemeProvider theme={theme}>
			<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"es"}>
				<Provider store={store}>
					<SnackbarProvider>
						<BrowserRouter>
							<Routes>
								<Route index element={<Login/>}/>
								<Route path="/login" element={<Login/>}/>
								<Route path="/logout" element={<Logout/>}/>
								<Route path="/candidate" element={<CandidatePage/>}/>
								<Route path="/evaluation" element={<SupportPage/>}/>
								<Route path="/recruitments" element={<PublicRecruitmentsPage/>}/>
								<Route path="/candidate/test/:testId" element={<CandidateTestPage/>}/>
								{/* Enlaces de antes de #14454: sin llave, la página no carga la prueba */}
								<Route path="/candidate/:candidateId/test/:testId" element={<CandidateTestPage/>}/>
								<Route path="/app" element={<App/>}>
									<Route index element={<AppWelcomePage/>}/>
									<Route path="/app/admin" element={<AdminLayout/>}>
										<Route index element={<AdminPage/>}/>
										{AdminBillingRoutes()}
										{AdminEmployeeRoutes()}
										{AdminRecruitmentRoutes()}
										{AdminAccountingRoutes()}
										{AdminMarketingRoutes()}
										{AdminComplianceRoutes()}
										<Route path="/app/admin/search" element={<SearchPage/>}/>
									</Route>
									{ConfigRoutes()}
									{ComplianceRedirects()}
									{EmployeeRoutes()}
									<Route path="/app/user/profile" element={<UserProfile/>}/>
								</Route>
								<Route path="*" element={<NotFoundPage/>}/>
							</Routes>
						</BrowserRouter>
					</SnackbarProvider>
				</Provider>
			</LocalizationProvider>
		</ThemeProvider>
	</React.StrictMode>
);